<template>
    <v-card class="elevation-0 pa-5 marginBottom" flat>
        <h1 class="fonte text-uppercase">Agendar uma Campanha</h1>
        <v-layout row wrap class="pa-3">
            <v-flex xs12 pb-2>
                <Calendario  />
            </v-flex>
        </v-layout>
    </v-card>
</template>


<script>
import moment from 'moment'
import * as helpers from './../../../helpers/helpers'
import {mapActions, mapGetters} from 'vuex'
import ListarCampanhas from './ListarCampanhas.vue'
import Calendario from './Calendario.vue'
export default {
    components: {
        ListarCampanhas,
        Calendario
    },
    data(){
        return{

        }
    },
    methods: {
        ...mapActions(['arquivos_sendCampanha', 'arquivos_getArquivoTemplateCampanha', 'arquivos_getAgendamentos']),

    },
    mounted(){
        this.arquivos_getArquivoTemplateCampanha({ativo: true})
        this.arquivos_getAgendamentos(moment(new Date()).format('MM'))
    }
}
</script>




// WEBPACK FOOTER //
// src/components/user/mensagens/Campanhas.vue